<div [innerHTML]="description" class="description"></div>
<mat-checkbox
  [disableRipple]="true"
  [formControl]="currentFormControl"
  class="checkbox"
  color="primary">
  {{placeholder}}
</mat-checkbox>
